import React, { useEffect } from "react";

import "./ChooseYourPlan.css";
const ChooseYourPlan = (props) => {

  useEffect( () => console.log("pack value received is -->", props.pack)
    ,[props.pack])

  const onOptionChange = (e) => {
    props.setPack(e.target.value);
  };

  return (
    <div className="choosePlan_section">
      <div className="row">
        <div className="col-lg-12">
          <h3>Choose your subscription</h3>
        </div>
      </div>

      <div className="plans_boxes">
        <div className="row">
          {/* <div className="col-lg-4">
            <label className="box">
              <div className="radio-text">
                <div className="radio-title">
                  <h4 className="plan-name">Cyberplus Daily</h4>
                </div>

                <div className="radio-pricepoint">
                  <span>2.10 AED/day</span>
                </div>
              </div>
              <div className="radio-button">
                <label className="radio-container">
                  <input
                    id="0"
                    onChange={(e) => onOptionChange(e)}
                    value="0"
                    type="radio"
                    name="choose"
                    checked={props.pack == "0"}

                  />
                  <span className="radio-checkcircle"></span>
                </label>
              </div>
            </label>
          </div> */}
          <div className="col-lg-4">
            <label className="box">
              <div className="radio-text">
                <div className="radio-title">
                  <h4 className="plan-name">Urduflix Monthly</h4>
                </div>

                <div className="radio-pricepoint">
                  <span>8.40 AED/month</span>
                </div>
              </div>
              <div className="radio-button">
                <label className="radio-container">
                  <input
                    id="0"
                    onChange={(e) => onOptionChange(e)}
                    value="0"
                    type="radio"
                    name="choose"
                    checked={props.pack == "0"}

                  />
                  <span className="radio-checkcircle"></span>
                </label>
              </div>
            </label>
          </div>
          {/* <div className="col-lg-4">
            <label className="box">
              <div className="radio-text">
                <div className="radio-title">
                  <h4 className="plan-name">BestIndie Weekly</h4>
                </div>

                <div className="radio-pricepoint">
                  <span>12.60 AED/week</span>
                </div>
              </div>
              <div className="radio-button">
                <label className="radio-container">
                  <input
                    id="1"
                    onChange={(e) => onOptionChange(e)}
                    type="radio"
                    name="choose"
                    value="1"
                    checked={props.pack == "1"}
                  />
                  <span className="radio-checkcircle"></span>
                </label>
              </div>
            </label>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ChooseYourPlan;
